/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/system";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
  },
}));

function ActionCell({ templateId, filterId, feed, handleDeleteAction }) {
  return (
    <SoftBox display="flex" alignItems="center">
      {/* <Link to="/templates/create-template">
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Preview product" placement="top">
            <Icon>visibility</Icon>
          </Tooltip>
        </SoftTypography>
      </Link> */}
      <SoftBox mx={2} style={{ display: feed ? "none" : "" }}>
        <HtmlTooltip
          placement={"top"}
          maxwidth={200}
          title={
            <React.Fragment>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                <div style={{ display: "block" }}>
                  {"You will not get feed until you apply any odd setting in this Filter."}
                </div>
              </div>
            </React.Fragment>
          }
        >
          <Icon sx={{ color: "rgb(203, 12, 159) !important", cursor: "help" }}>
            report_problem_outlined_icon{" "}
          </Icon>
        </HtmlTooltip>
      </SoftBox>
      <SoftBox mx={2}>
        <Link
          to={`/feed-settings/filters/${filterId}/edit-filter`}
          state={{ stateTemplate: templateId, stateFilter: filterId }}
        >
          <SoftTypography
            variant="body1"
            color="secondary"
            sx={{ cursor: "pointer", lineHeight: 0 }}
          >
            <Tooltip title="Edit Filter" placement="top">
              <Icon>edit</Icon>
            </Tooltip>
          </SoftTypography>
        </Link>
      </SoftBox>
      <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
        <Tooltip title="Delete Filter" placement="top">
          <Icon onClick={handleDeleteAction}>delete</Icon>
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  templateId: PropTypes.number,
  filterId: PropTypes.number,
  feed: PropTypes.bool,
  handleDeleteAction: PropTypes.func,
};

export default ActionCell;
